import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { Box } from 'fw/components';
import * as App from 'modules/app/App';
import API from 'fw/system/API';
import List from './SetupList';
import * as Notifications from 'fw/globals/Notifications';
import ColumnSettingsModal from './ColumnSettingsModal';

class SetupListView extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState(props) {
        let state;

        // If we are restoring previous search data, we don't trigger search
        if (props.prevSearchData)
            state = props.prevSearchData
        else {
            // Get column settings from local storage.
            const colSettingsStr = localStorage.getItem("columnSettings");
            let columns = props.setupProps.list.columns;

            // If configuration exists
            if (colSettingsStr) {
                let colSettings = JSON.parse(colSettingsStr);

                // If configuration for the current setup exists
                if (colSettings && colSettings[props.setupProps.setupKey]) {
                    colSettings[props.setupProps.setupKey].forEach(cs => {
                        // Hide every column that the user has hidden.
                        columns.forEach(c => {
                            if (c.key === cs.key)
                                c.hidden = cs.hidden;
                        });
                    });
                }
            }

            // If we don't have previous search data, we trigger search
            state = {
                list: null,
                columns: columns,
                showMoreRecords: false,
                rowCount: props.rowCount,
                filters: {},
                sorting: {
                    sortField: props.setupProps.sortField || props.setupProps.list.columns[0].key,
                    sortDirection: props.setupProps.sortDirection || props.sortDirection
                }
            };
        }

        return state;
    }

    search = (opts, callback) => {
        const rq = Object.assign(
            this.state.filters,
            this.state.sorting,
            { rowCount: this.state.rowCount }
        );
        new API().post(this.props.setupProps.list.url, rq,
            {
                success: (r) => {
                    // Proceed to first result?
                    if (r.data.count === 1) {
                        const redirect = this.props.setupProps.redirectOnSingleResult /*&& this.props.setupProps.redirectOnSingleResult(rq)*/;

                        if (redirect) {
                            App.updateLastSetupTabIsSingle(true);
                            let url = this.props.setupProps.match.url + '/' + r.data.items[0][this.props.setupProps.list.rowKey];
                            this.props.history.push(url);
                            return;
                        }
                    }
                    App.updateLastSetupTabIsSingle(false);

                    // Store search results
                    this.setState({
                        list: r.data,
                        showMoreRecords: r.data.count >= this.state.rowCount
                    }, function () {
                        this.props.onSearch(this.state)
                    });

                    // Only show notifications if user triggred the search, to avoid messages
                    // after save or other auto refreshes
                    if (!opts || !opts.systemTriggered) {
                        if (r.data.count === 0)
                            Notifications.error("No results found.");
                    }

                    // Callback
                    if (callback)
                        callback();
                },
                error: (r) => {
                    Notifications.error(r.error.errorMessage);
                }
            });
    }

    // Handlers
    handleSelect = (id) => {
        if (!this.props.disableSelect)
            this.props.onSelect(id);
    }

    handleSort = (sortField, sortDirection) => {
        this.setState({
            sorting: {
                sortField: sortField,
                sortDirection: sortDirection
            }
        }, function () { this.search(); });
    }

    handleSearch = (filters, callback) => {
        this.setState({
            filters: filters,
            editing: false
        }, function () {
            this.search(null, callback);
        });
    }

    handleReset = (filters, callback) => {
        if (this.props.triggerInitialSearch === false)
            this.setState({ list: null });
        else {
            this.setState({
                filters: filters,
                editing: false
            }, function () {
                this.search(null, callback);
            });
        }
    }

    handleError = (error) => {
        Notifications.error(error.errorMessage);
    }

    handleLoadMoreResults = () => {
        this.setState({
            rowCount: this.state.rowCount + this.props.rowCount
        }, function () {
            this.search()
        });
    }

    handleCustomAction = () => {
        const rq = Object.assign(
            this.state.filters,
            this.state.sorting,
            {
                rowCount: this.props.exportLimit,
                columns: this.state.columns,
                search: this.search
            },
        );

        this.props.customAction.onExecute(rq);
    }

    handleExport = () => {
        const rq = Object.assign(
            this.state.filters,
            this.state.sorting,
            {
                rowCount: this.props.exportLimit,
                columns: this.state.columns
            },
        );

        new API().post(this.props.setupProps.list.url + 'export', rq,
            {
                success: (sr) => {
                    new API().download(sr.data);
                }
            });
    }

    handleOpenColSettings = () => {
        this._dialog.open([...this.state.columns], this.props.setupProps.setupKey, (columns) => {
            this.setState({ columns: columns });
        });
    }

    componentDidMount() {
        if (!this.props.enableSearch)
            this.handleSearch({});
    }

    // React
    render() {
        const Search = this.props.setupProps.Search;

        return (
            <Box boxStyle="primary">
                <ColumnSettingsModal ref={(dialog) => this._dialog = dialog} />

                {this.props.enableSearch &&
                    <Search
                        setupKey={this.props.setupProps.setupKey}
                        enableColumnSettings={this.props.setupProps.enableColumnSettings}
                        triggerInitialSearch={this.props.triggerInitialSearch}
                        onSearch={this.handleSearch}
                        onReset={this.handleReset}
                        onError={this.handleError}
                        OnOpenColSettings={this.handleOpenColSettings}
                        filters={this.state.filters}
						searchProps={this.props.setupProps.searchProps} />
                }

                <List
                    columns={this.state.columns}
                    rowKey={this.props.setupProps.list.rowKey}
                    sortField={this.state.sorting.sortField}
                    sortDirection={this.state.sorting.sortDirection}
                    filters={this.state.filters}
                    list={this.state.list}
                    triggerInitialSearch={this.props.triggerInitialSearch}
                    onSelect={this.handleSelect}
                    enableRowSelection={this.props.setupProps.enableRowSelection}
                    maxRowSelection={this.props.setupProps.maxRowSelection}
                    maxRowSelectionReachedMessage={this.props.setupProps.maxRowSelectionReachedMessage}
                    rowSelectionTooltip={this.props.setupProps.rowSelectionTooltip}
                    onRowsSelectedChange={this.props.setupProps.onRowsSelectedChange}
                    onSort={this.handleSort} />
                <br />

                {this.props.enableExport && this.state.list &&
                    <Button
                        onClick={this.handleExport}
                        className="btn btn-default pull-left" >
                        <Glyphicon glyph="glyphicon glyphicon-export" style={{ marginRight: 10 }} />Export CSV
                    </Button>
                }

                {this.props.customAction != null && this.state.list &&
                    <React.Fragment>
                        <Button
                            onClick={this.handleCustomAction}
                            disabled={this.props.customAction.disabled}
                            bsStyle={this.props.customActionStyle.bsStyle}
                            className="pull-left" style={{marginLeft: this.props.enableExport ? "5px" : "0px"}} >
                            <Glyphicon glyph={`glyphicon glyphicon-${this.props.customActionStyle.glyphicon}`} style={{ marginRight: 10 }} />{this.props.customAction.title}
                        </Button>
                        {this.props.customActionStyle.label ?
                            this.props.customActionStyle.label        
                        : null}
                    </React.Fragment>
                }

                {this.state.showMoreRecords &&
                    <Button id="btnViewMoreResults" className="pull-right" onClick={this.handleLoadMoreResults}>
                        <Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results
                    </Button>
                }
            </Box>
        );
    }
}

SetupListView.defaultProps = {
    enableSearch: true,
    enableExport: true,
    exportLimit: 5000,
    rowCount: 100,
    sortDirection: "ASC",
    customAction: null,
    customActionStyle: {
        glyphicon: "export",
        bsStyle: "default"
    },
    disableSelect: false,
    triggerInitialSearch: true
};

export default SetupListView;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupListView.js